// components/ui/Card.tsx
import { type ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  glow?: boolean;
  onClick?: () => void;
}

interface CardHeaderProps {
  children: ReactNode;
  className?: string;
}

interface CardBodyProps {
  children: ReactNode;
  className?: string;
}

interface CardFooterProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className, hover, glow, onClick }: CardProps) {
  return (
    <div
      className={cn(
        'bg-surface rounded-lg border border-border overflow-hidden',
        'transition-all duration-normal',
        hover && 'hover:bg-surface-hover hover:border-border-strong cursor-pointer',
        glow && 'hover:border-primary hover:shadow-glow cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className }: CardHeaderProps) {
  return (
    <div className={cn('px-5 py-4 border-b border-border-subtle', className)}>
      {children}
    </div>
  );
}

export function CardBody({ children, className }: CardBodyProps) {
  return (
    <div className={cn('p-5', className)}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className }: CardFooterProps) {
  return (
    <div className={cn('px-5 py-4 border-t border-border-subtle bg-bg-subtle', className)}>
      {children}
    </div>
  );
}
